import React from 'react';

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="card p-6">
        <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          By using this website and placing an order, you agree to the following terms.
        </p>

        <div className="space-y-6 text-gray-600 dark:text-gray-400">
          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">General</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Prices and availability may change without notice.</li>
              <li>We reserve the right to refuse or cancel orders in certain cases.</li>
              <li>You are responsible for providing accurate delivery details.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Orders & Payments</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Orders are confirmed after successful placement on the website.</li>
              <li>For Easypaisa payments, orders may require verification.</li>
              <li>Cash on Delivery is available in eligible areas.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Returns</h2>
            <p>
              Returns and exchanges are governed by our Return Policy. Please review it before
              making a purchase.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, TRENDZ is not liable for indirect or
              consequential damages arising from use of this website or products.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Contact</h2>
            <p>
              For questions, contact <strong>support@justwest.com</strong> or{' '}
              <strong>03708426610</strong>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;

